/* 


@PRAKT


   _____________________________________________________________

   |
   | COLLECTION BANNER
   |
   _____________________________________________________________
*/

import gsap from 'gsap';

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class CollectionBanner {
    constructor() {
        this.init();
    }

    init() {
        this.banner = document.querySelector( '.hcc_collection_banner' );        
        if( !this.banner ) return;
        this.description_wrapper = this.banner.querySelector( '.description_wrapper' );
        if( !this.description_wrapper ) return;
        this.status = false;
        this.localization = window.collection_banner_localization;
        this.description_container = this.banner.querySelector( '.description_container' );
        this.description = this.banner.querySelector( '.description_container p' );
        this.checkDescContent();
        this.resize();
    }

    checkDescContent() {
        const banner_height = this.banner.getBoundingClientRect().height;
        const description_height = this.description.getBoundingClientRect().height;
        if( description_height > banner_height * 0.25 ) {
            this.description_container.classList.add( 'mask' );
            this.addButton();
            this.buttonAction();
        } else {
            if( !this.button ) return;
            this.description_container.classList.remove( 'mask' );
            this.description_container.removeAttribute( 'style' );
            this.button.remove();
            this.status = false;
        }
    }

    addButton() {
        this.button = document.createElement( 'div' );
        this.button.className = 'show_desc_button';
        this.button.innerText = this.localization.buttonlabel;
        this.description_wrapper.appendChild( this.button );
    }

    buttonAction() {
        this.button.addEventListener( 'click', () => {
            ( !this.status ) ? this.open() : this.close();
        } );
    }

    open() {
        this.status = true;
        this.description_container_init_height = this.description_container.getBoundingClientRect().height;
        this.button.innerText = this.localization.buttonlabelhide;
        gsap.to( this.description_container, {
            duration: 1,
            ease: 'power3.inOut',
            height: 'auto',
            mask: 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 0%)',
        } );
    }

    close() {
        this.status = false;
        this.button.innerText = this.localization.buttonlabel;
        gsap.to( this.description_container, {
            duration: 1,
            ease: 'power3.inOut',
            height: this.description_container_init_height,
            mask: 'linear-gradient(0deg, rgba(0,0,0,0) 0%, rgba(0,0,0,1) 100%)'
        } );
    }

    resize() {
        window.addEventListener( 'resize', () => {
            this.checkDescContent();
        } );
    }
}